import type { UserProfile } from '../../hooks/useAuth';

const ONBOARDING_WELCOME_KEY_PREFIX = 'help_onboarding_welcome_seen_v1';
const HELP_HINTS_KEY_PREFIX = 'help_dismissed_hints_v1';

const getStorageKey = (prefix: string, user: UserProfile | null): string => {
  const userKey = user?.uid || user?.email || 'anonymous';
  return `${prefix}:${userKey}`;
};

export const hasSeenOnboardingWelcome = (user: UserProfile | null): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const key = getStorageKey(ONBOARDING_WELCOME_KEY_PREFIX, user);
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

export const markOnboardingWelcomeSeen = (user: UserProfile | null): void => {
  if (typeof window === 'undefined') return;
  try {
    const key = getStorageKey(ONBOARDING_WELCOME_KEY_PREFIX, user);
    window.localStorage.setItem(key, '1');
  } catch {
    // no-op
  }
};

export const getDismissedHelpHints = (user: UserProfile | null): Record<string, boolean> => {
  if (typeof window === 'undefined') return {};
  try {
    const key = getStorageKey(HELP_HINTS_KEY_PREFIX, user);
    const raw = window.localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};

    const result: Record<string, boolean> = {};
    for (const [hintId, dismissed] of Object.entries(parsed)) {
      if (dismissed === true) {
        result[hintId] = true;
      }
    }
    return result;
  } catch {
    return {};
  }
};

export const markHelpHintDismissed = (user: UserProfile | null, hintId: string): void => {
  if (typeof window === 'undefined') return;
  try {
    const key = getStorageKey(HELP_HINTS_KEY_PREFIX, user);
    const current = getDismissedHelpHints(user);
    current[hintId] = true;
    window.localStorage.setItem(key, JSON.stringify(current));
  } catch {
    // no-op
  }
};
